import { ModelBase } from './model';

class LearningGroupAssignment extends ModelBase {
  static namespace = 'learning_assignment';
}
export default LearningGroupAssignment.register();
